import React, { useEffect, useState } from 'react';
import BroadcastPage from '../pages/BroadcastPage';
import DashboardPage from '../pages/DashboardPage';
import ActionsGuidePage from '../pages/ActionsGuidePage';
import FindDevicePage from '../pages/FindDevicePage';
import StatusPage from '../pages/StatusPage';
import UrgentPage from '../pages/UrgentPage';
import MapPage from '../pages/MapPage';

/** Sections that stay mounted after the first visit so returning does not refetch. */
const SECTION_TABS = ['dashboard', 'status', 'urgent', 'map', 'broadcast', 'find', 'rules'];

/**
 * Keep every risks section mounted after the first visit.
 * Map still tears down the Yandex widget while hidden (activeTab !== 'map').
 */
export default function StickyMainPanels({ activeTab, onTabChange }) {
  const [visited, setVisited] = useState(() =>
    SECTION_TABS.includes(activeTab) ? { [activeTab]: true } : {},
  );

  useEffect(() => {
    if (!SECTION_TABS.includes(activeTab)) {
      return;
    }
    setVisited((prev) => (prev[activeTab] ? prev : { ...prev, [activeTab]: true }));
  }, [activeTab]);

  const show = (tab) => Boolean(visited[tab]) || activeTab === tab;

  return (
    <>
      {show('dashboard') ? (
        <div hidden={activeTab !== 'dashboard'} aria-hidden={activeTab !== 'dashboard'}>
          <DashboardPage activeTab={activeTab} onTabChange={onTabChange} />
        </div>
      ) : null}
      {show('status') ? (
        <div hidden={activeTab !== 'status'} aria-hidden={activeTab !== 'status'}>
          <StatusPage activeTab={activeTab} onTabChange={onTabChange} />
        </div>
      ) : null}
      {show('urgent') ? (
        <div hidden={activeTab !== 'urgent'} aria-hidden={activeTab !== 'urgent'}>
          <UrgentPage activeTab={activeTab} onTabChange={onTabChange} />
        </div>
      ) : null}
      {show('map') ? (
        <div hidden={activeTab !== 'map'} aria-hidden={activeTab !== 'map'}>
          <MapPage activeTab={activeTab} onTabChange={onTabChange} />
        </div>
      ) : null}
      {show('broadcast') ? (
        <div hidden={activeTab !== 'broadcast'} aria-hidden={activeTab !== 'broadcast'}>
          <BroadcastPage panelActive={activeTab === 'broadcast'} activeTab={activeTab} onTabChange={onTabChange} />
        </div>
      ) : null}
      {show('find') ? (
        <div hidden={activeTab !== 'find'} aria-hidden={activeTab !== 'find'}>
          <FindDevicePage activeTab={activeTab} onTabChange={onTabChange} />
        </div>
      ) : null}
      {show('rules') ? (
        <div hidden={activeTab !== 'rules'} aria-hidden={activeTab !== 'rules'}>
          <ActionsGuidePage />
        </div>
      ) : null}
    </>
  );
}
